module.exports = __webpack_public_path__ + "media/images/emblems/Unteraegeri_Wappen-cf6ef1530a4dc17c1dfcc7ae36d7e810.svg";